import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
} from "@mui/material";
import formatDateAndTime from "../../common/formatDateAndTime";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import moment from "moment";
import formatDate from "../../common/Formatdate";
import toast from "react-hot-toast";
import { BlinkBlur } from "react-loading-indicators";
import EditSquareIcon from "@mui/icons-material/EditSquare";
import getactions from "../../common/getactions";

const imagestyle = {
  position: "fixed", // <--- change here
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 20,
  p: 4,
  overflowY: "auto",
  maxHeight: "80vh",
};

const InfoTable = ({ title, rows }) => (
  <div className="overflow-hidden rounded-lg shadow mb-8 mt-4">
    <table className="w-full text-left bg-white">
      <thead className="bg-[#34495e] text-white">
        <tr>
          <th className="px-6 py-4" colSpan={2}>
            {title}
          </th>
        </tr>
      </thead>
      <tbody className="text-sm divide-y divide-gray-200">
        {rows.map(([label, value, editProps], idx) => (
          <tr key={idx}>
            <td className="font-semibold px-6 py-3 text-[#2c3e50] w-1/3">
              {label}
            </td>
            <td className="px-6 py-3 text-[#34495e] flex gap-4 items-center">
              {label === "Date of Birth" && editProps ? (
                editProps.isEditing ? (
                  <>
                    <TextField
                      type="date"
                      value={editProps.dobValue}
                      onChange={(e) => editProps.setDobValue(e.target.value)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!editProps.dobError}
                      helperText={editProps.dobError}
                      sx={{ minWidth: 150 }}
                    />
                    <Button
                      onClick={editProps.handleDobSave}
                      size="small"
                      variant="contained"
                      color="primary"
                      disabled={editProps.dobLoading}
                      sx={{ ml: 1 }}
                    >
                      {editProps.dobLoading ? "Saving..." : "Save"}
                    </Button>
                    <Button
                      onClick={editProps.cancelEdit}
                      size="small"
                      variant="outlined"
                      color="error"
                      sx={{ ml: 1 }}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <>
                    {value}
                    <div
                      className="cursor-pointer"
                      onClick={editProps.startEdit}
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          fill="#1976d2"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zm14.71-9.04c.39-.39.39-1.02 0-1.41l-2.54-2.54a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                        </svg>
                      </span>
                    </div>
                  </>
                )
              ) : label === "Email Address" && editProps ? (
                editProps.isEditing ? (
                  <>
                    <TextField
                      type="email"
                      value={editProps.emailValue}
                      onChange={(e) => editProps.setEmailValue(e.target.value)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!editProps.emailError}
                      helperText={editProps.emailError}
                      sx={{ minWidth: 220 }}
                    />
                    <Button
                      onClick={editProps.handleEmailSave}
                      size="small"
                      variant="contained"
                      color="primary"
                      disabled={editProps.emailLoading}
                      sx={{ ml: 1 }}
                    >
                      {editProps.emailLoading ? "Saving..." : "Save"}
                    </Button>
                    <Button
                      onClick={editProps.cancelEdit}
                      size="small"
                      variant="outlined"
                      color="error"
                      sx={{ ml: 1 }}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <>
                    {value}
                    <div
                      className="cursor-pointer"
                      onClick={editProps.startEdit}
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          fill="#1976d2"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zm14.71-9.04c.39-.39.39-1.02 0-1.41l-2.54-2.54a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                        </svg>
                      </span>
                    </div>
                  </>
                )
              ) : (
                value
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const contactAction = (action, value) => {
  if (!value) return;

  switch (action) {
    case "Call":
      window.location.href = `tel:${value}`;
      break;

    case "SMS":
      window.location.href = `sms:${value}`;
      break;

    case "Email":
      window.location.href = `mailto:${value}`;
      break;

    case "WhatsApp":
      window.open(`https://wa.me/${value}?text=Hello`, "_blank");
      break;

    default:
      alert(`${action}: ${value}`);
      break;
  }
};

const ContactButton = ({ action, value, label, icon, onClick }) => {
  const href =
    action === "WhatsApp"
      ? `https://wa.me/${value}?text=Hello`
      : action === "Email"
        ? `mailto:${value}`
        : undefined;

  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer" className="ml-3">
      {icon} {label}
    </a>
  ) : (
    <button onClick={onClick} className="ml-3">
      {icon} {label}
    </button>
  );
};

const Customerdetails = ({
  summaryDetails,
  getBookingDetail,
  systemUserData,
  refresh,
}) => {
  const customerDocumentType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.customerDocumentType;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  delete customerDocumentType?.inverted;
  const customerDocumentStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.customerDocumentType;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [viewImage, setViewImage] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [openImage, setOpenImage] = useState(false);
  const [customerDocuments, setCustomerDocuments] = useState(null);
  const [profileInfo, setProfileInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditingDob, setIsEditingDob] = useState(false);
  const [dobValue, setDobValue] = useState("");
  const [dobLoading, setDobLoading] = useState(false);
  const [dobError, setDobError] = useState("");
  const [isEditingEmail, setIsEditingEmail] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [isEdit, setIsEdit] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editType, setEditType] = useState("");
  const [previousValue, setPreviousValue] = useState("");
  const [changeValue, setChangeValue] = useState("");

  // CALL LOG STATES
  const [callSid, setCallSid] = useState(null);
  const [showCapture, setShowCapture] = useState(false);
  const [callLogs, setCallLogs] = useState([]);

  // Save DOB API
  const handleDobSave = async () => {
    setDobLoading(true);
    setDobError("");
    try {
      const response = await fetch(`${apiUrl}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: summaryDetails?.customerId,
          dob: dobValue,
          updateBookings: true,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Date of Birth updated successfully");
        setIsEditingDob(false);
        getBookingDetail(refresh?.inquiryID, "inquiry");
        // paymentDetails(summaryDetails?.id); // refresh profile
      } else {
        setDobError(data?.message || "Failed to update DOB");
      }
    } catch (error) {
      setDobError("Error updating DOB");
    }
    setDobLoading(false);
  };

  const startEdit = () => {
    setDobValue(summaryDetails?.dob || "");
    setDobError("");
    setIsEditingDob(true);
  };
  const cancelEdit = () => {
    setIsEditingDob(false);
    setDobError("");
  };

  const startEmailEdit = () => {
    setEmailValue(summaryDetails?.customerEmail || "");
    setEmailError("");
    setIsEditingEmail(true);
  };

  const cancelEmailEdit = () => {
    setIsEditingEmail(false);
    setEmailError("");
  };

  const validateEmail = (value) => {
    if (!value || String(value).trim() === "") return "Email is required";
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!re.test(String(value).trim())) return "Invalid email address";
    return "";
  };

  const handleEmailChange = (value) => {
    // InfoTable passes the raw value (string), keep it simple
    setEmailValue(value);
    const err = validateEmail(value);
    setEmailError(err);
  };

  const handleEmailSave = async () => {
    setEmailLoading(true);
    setEmailError("");

    // Pre-submit validation
    const preErr = validateEmail(emailValue);
    if (preErr) {
      setEmailError(preErr);
      setEmailLoading(false);
      return;
    }
    try {
      const response = await fetch(`${apiUrl}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          id: summaryDetails?.customerId,
          email: emailValue,
          updateBookings: true,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Email updated successfully");
        setIsEditingEmail(false);
        getBookingDetail(refresh?.inquiryID, "inquiry");
      } else {
        setEmailError(data?.message || "Failed to update Email");
      }
    } catch (error) {
      setEmailError("Error updating Email");
    }
    setEmailLoading(false);
  };

  const getUsersDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/users/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setProfileInfo(data?.entityValue);
      }
      return data;
    } catch (error) {
      console.error("Error fetching customer documents:", error);
      setCustomerDocuments([]);
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) {
      getUsersDetails(summaryDetails?.customerId);
    }
  }, [summaryDetails]);

  const handleViewOpen = (url) => {
    // normalize to an array of urls so modal can show multiple attachments
    if (!url) {
      setViewImage(null);
      return;
    }

    if (Array.isArray(url)) {
      setViewImage(url.filter(Boolean));
      return;
    }

    // single string -> wrap in array
    setViewImage([url]);
  };

  const handleViewClose = () => {
    setViewImage(null);
    setSelectedRow(null);
    setInputValues({});
    setSelectedFile(null);
    setErrors({});
  };

  const handleImageClose = () => {
    setOpenImage(false);
    setInputValues({});
    setSelectedFile(null);
    setErrors({});
    setIsEdit({});
  };

  const handleImageOpen = (type, row = null) => {
    if (type === "new") {
      setOpenImage(true);
    } else {
      setIsEdit({ isEdit: true, row: row });
      setOpenImage(true);
      const selectedDoc = row || selectedRow;
      setInputValues({
        documentype: selectedDoc?.docType || "",
        name: selectedDoc?.docName || "",
        docidentification: selectedDoc?.identificationNo || "",
        validfrom: selectedDoc?.startDate
          ? moment(selectedDoc.startDate).format("YYYY-MM-DD")
          : "",
        validto: selectedDoc?.endDate
          ? moment(selectedDoc.endDate).format("YYYY-MM-DD")
          : "",
        description: selectedDoc?.description || "",
      });
      setSelectedFile(
        selectedDoc?.attachments ? JSON.parse(selectedDoc.attachments) : null,
      );
    }
  };

  const validateField = (key, value) => {
    let errorMsg = "";

    if (!value && key !== "uploadfile") {
      errorMsg = "This field is required";
    } else {
      if (key === "name" && !/^[a-zA-Z ]*$/.test(value)) {
        errorMsg = "Name must be at least 3 characters and only alphabets";
      }
      if (key === "docidentification" && value.length < 5) {
        errorMsg = "Doc ID must be at least 5 characters";
      }
      if (key === "documentype" && !value) {
        errorMsg = "Please select a document type";
      }
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleInputChange = (key, event) => {
    const value =
      event?.target?.value !== undefined ? event.target.value : event;
    setInputValues((prev) => ({ ...prev, [key]: value }));
    validateField(key, value);
  };

  const handleFileChange = async (event) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "pettyCash");
    formData.append("fileTags", "vehicle");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setLoading(false);
        setSelectedFile(data?.uploaded);
      } else {
        setLoading(false);
        setSelectedFile(null);
      }
      return data;
    } catch (error) {
      setLoading(false);
      return console.error("Error fetching image upload in charges:", error);
    }
  };

  useEffect(() => {
    if (summaryDetails?.customerId) {
      getCustomerDocuments();
    }
  }, [summaryDetails?.customerId]);

  const getCustomerDocuments = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/customerdocuments?limit=100&userId=${summaryDetails?.customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setCustomerDocuments(data?.entities?.rows);
      } else {
        setCustomerDocuments([]); // prevent null issues
      }
      return data;
    } catch (error) {
      console.error("Error fetching customer documents:", error);
      setCustomerDocuments([]);
    }
  };

  useEffect(() => {
    const docType = customerDocumentStatus[inputValues?.documentype];

    if (docType === "Driving License") {
      const fromDate = inputValues?.validfrom
        ? new Date(inputValues.validfrom)
        : null;
      const toDate = inputValues?.validto
        ? new Date(inputValues.validto)
        : null;

      if (
        fromDate instanceof Date &&
        !isNaN(fromDate) &&
        toDate instanceof Date &&
        !isNaN(toDate)
      ) {
        // build a "one year later" date
        const oneYearLater = new Date(fromDate);
        oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);

        if (toDate < oneYearLater) {
          setErrors((prev) => ({
            ...prev,
            validto: "Driving License must be valid for at least 1 year",
          }));
        } else {
          setErrors((prev) => ({ ...prev, validto: "" }));
        }
      } else {
        setErrors((prev) => ({ ...prev, validto: "" }));
      }
    } else if (docType === "Aadhar") {
      const dob = inputValues?.validfrom
        ? new Date(inputValues.validfrom)
        : null;
      const checkDate = inputValues?.validto
        ? new Date(inputValues.validto)
        : new Date();

      const twentyFirstBirthday = new Date(dob);
      twentyFirstBirthday.setFullYear(twentyFirstBirthday.getFullYear() + 21);

      if (checkDate < twentyFirstBirthday) {
        setErrors((prev) => ({
          ...prev,
          validfrom: "For Aadhar, age must be at least 21 years",
        }));
      }

      // …rest of code
    }
  }, [inputValues?.validfrom, inputValues?.validto, inputValues?.documentype]);

  const handleSave = async () => {
    const docTypeStaus = inputValues?.documentype;
    let payload;
    if (isEdit?.isEdit) {
      payload = {
        id: isEdit?.row?.id,
        docName: inputValues?.name,
        identificationNo: inputValues?.docidentification,
        startDate: inputValues?.validfrom,
        endDate: inputValues?.validto,
        docType: docTypeStaus,
        description: inputValues?.description,
        imageUrl: selectedFile[0]?.url,
        fileName: selectedFile[0]?.fileName,
        userId: summaryDetails?.customerId,
        attachments: JSON.stringify(selectedFile),
      };
    } else {
      payload = {
        docName: inputValues?.name,
        identificationNo: inputValues?.docidentification,
        startDate: inputValues?.validfrom,
        endDate: inputValues?.validto,
        docType: docTypeStaus,
        description: inputValues?.description,
        imageUrl: selectedFile[0]?.url,
        fileName: selectedFile[0]?.fileName,
        userId: summaryDetails?.customerId,
        attachments: JSON.stringify(selectedFile),
      };
    }
    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/api/customerdocuments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        await getCustomerDocuments(data);
        setOpenImage(false);
        setInputValues({});
        setSelectedFile(null);
        setErrors({});
        setIsEdit({});
      } else {
        setLoading(false);
        setOpenImage(false);
        setInputValues({});
        setSelectedFile(null);
        setErrors({});
        setIsEdit({});
        toast.error(data?.message, {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "40px",
          },
        });
      }
      return data;
    } catch (error) {
      return console.error("Error saving document:", error);
    }
  };

  const approveCustomerDocuments = async (message) => {
    let payload;

    if (message === "approve") {
      payload = {
        id: selectedRow?.id,
        isVerified: true,
        isDocVerified: true,
        userId: selectedRow?.userId,
        approvedBy: profile?.id,
      };
    } else if (message === "reject") {
      payload = {
        id: selectedRow?.id,
        isRejected: true,
        isDocVerified: false,
        userId: selectedRow?.userId,
        approvedBy: profile?.id,
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/customerdocuments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        if (message === "approve") {
          await getCustomerDocuments(data);
          setViewImage(false);
          setSelectedRow(null);
          getBookingDetail(summaryDetails?.inquiryId, "inquiry");
        } else if (message === "reject") {
          await getCustomerDocuments(data);
          setViewImage(false);
          setSelectedRow(null);
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const customerDocumentsInputs = [
    {
      label: "Document Type",
      value: "documentype",
      type: "dropdown",
      subCategory: Object.entries(customerDocumentType || {}).map(
        ([key, value]) => ({
          id: key, // store id
          label: value, // display name
        }),
      ),
    },
  ];

  const [customerDocumentsField, setCustomerDocumentsField] = useState(
    customerDocumentsInputs,
  );

  useEffect(() => {
    if (!inputValues?.documentype) return;

    const docType = customerDocumentStatus[inputValues.documentype];
    let newFields = [...customerDocumentsInputs];

    if (docType === "Driving License") {
      newFields = [
        ...newFields,
        { label: "Name", value: "name", type: "text" },
        {
          label: "Doc Identification",
          value: "docidentification",
          type: "text",
        },
        { label: "Valid From", value: "validfrom", type: "date" },
        { label: "Valid To", value: "validto", type: "date" },
        { label: "Description", value: "description", type: "text" },
        { label: "Upload File", value: "uploadfile", type: "file" },
      ];
    } else if (docType === "Aadhar") {
      newFields = [
        ...newFields,
        { label: "Name", value: "name", type: "text" },
        {
          label: "Doc Identification",
          value: "docidentification",
          type: "text",
        },
        { label: "DOB", value: "validfrom", type: "date" },
        { label: "Current Date", value: "validto", type: "date" },
        { label: "Description", value: "description", type: "text" },
        { label: "Upload File", value: "uploadfile", type: "file" },
      ];
    } else {
      newFields = [
        ...newFields,
        { label: "Name", value: "name", type: "text" },
        {
          label: "Doc Identification",
          value: "docidentification",
          type: "text",
        },
        { label: "Upload File", value: "uploadfile", type: "file" },
      ];
    }

    setCustomerDocumentsField(newFields);
  }, [inputValues?.documentype]);

  const isFormValid = () => {
    const hasErrors = Object.values(errors).some((err) => err);

    const requiredFields = customerDocumentsField.map((f) => f.value);
    const missingValues = requiredFields?.some(
      (field) =>
        field !== "uploadfile" &&
        (!inputValues[field] || String(inputValues[field]).trim() === ""),
    );

    const missingFile =
      requiredFields?.includes("uploadfile") && !selectedFile?.length;

    return !hasErrors && !missingValues && !missingFile;
  };

  useEffect(() => {
    const docType = customerDocumentStatus[inputValues?.documentype];

    if (docType === "Aadhar") {
      const today = moment().format("YYYY-MM-DD"); // format for date input
      if (!inputValues?.validto) {
        setInputValues((prev) => ({
          ...prev,
          validto: today,
        }));
      }
    }
  }, [inputValues?.documentype]);

  const makeCustomerCall = async (mobile) => {
    if (!token) {
      return toast.error("Session timeout - please log in again");
    }
    try {
      const payload = {
        from: String(profile?.mobile || ""),
        to: mobile,
        bookingId: summaryDetails?.id,
      };

      const response = await fetch(
        `${apiUrl}/api/customersupportcalldetails/makecall`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        const sid =
          data?.callSid || data?.dataValues?.callSid || data?.dataValues?.sId;

        if (!sid) {
          toast.error("callSid not received from server");
          return;
        }

        setCallSid(sid);

        toast.success("Calling customer...");

        setTimeout(() => {
          setShowCapture(true);
        }, 5000);
      } else {
        toast.error(data?.message || "Call failed");
      }
    } catch (error) {
      console.error("MAKE CALL ERROR:", error);
      toast.error("Call failed");
    }
  };

  const captureCallDetails = async (sId) => {
    try {
      // if (!callSid) {
      //   toast.error("CallSid missing");
      //   return;
      // }

      const payload = {
        callSid: callSid ? callSid : sId,
        bookingId: summaryDetails?.id,
      };

      const response = await fetch(
        `${apiUrl}/api/customersupportcalldetails/fetchcalldetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success("Call details captured");

        setShowCapture(false);
        fetchCallLogs();
      } else {
        toast.error(data?.message || "Unable to fetch call details");
      }
    } catch (error) {
      console.error("CAPTURE ERROR:", error);
      toast.error("Capture API failed");
    }
  };

  const fetchCallLogs = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/customersupportcalldetails?bookingId=${summaryDetails?.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setCallLogs(data?.entities?.rows || []);
      }
    } catch (error) {
      console.error("FETCH CALL LOG ERROR:", error);
    }
  };

  useEffect(() => {
    if (summaryDetails?.id) {
      fetchCallLogs();
    }
  }, [summaryDetails?.id]);

  const openEditModal = (type, value) => {
    setEditType(type);

    if (type === "customer") {
      setChangeValue(profileInfo?.name || "");
      setPreviousValue(profileInfo?.email || "");
      setInputValues((prev) => ({
        ...prev,
        customerDob: profileInfo?.dob
          ? moment(profileInfo.dob).format("YYYY-MM-DD")
          : "",
      }));
    } else {
      setPreviousValue(value || "");
      setChangeValue(value || "");
    }

    setEmailError("");
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
    setEditType("");
    setPreviousValue("");
    setChangeValue("");
  };

  const handleCustomerDetailsSave = async () => {
    try {     
      let payload = {
        id: summaryDetails?.customerId,
        updateBookings: true,
        name : changeValue || profileInfo?.name,
        email : previousValue || profileInfo?.customerEmail,
        dob : inputValues?.customerDob || profileInfo?.dob,
      };
    
      const response = await fetch(`${apiUrl}/api/v2/users/update-customer-details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success("Customer details updated successfully");
        closeEditModal();
        getBookingDetail(refresh?.inquiryID, "inquiry");
        getUsersDetails(summaryDetails?.customerId);
      } else {
        toast.error(data?.message || "Update failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      {editModalOpen && (
        <Modal open={editModalOpen} onClose={closeEditModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: editType === "customer" ? 600 : 450,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <>
              <h2 className="text-xl font-semibold mb-5">
                Edit Customer Details
              </h2>
              <div className="space-y-5">
                <TextField
                  fullWidth
                  label="Full Name"
                  value={changeValue}
                  onChange={(e) => setChangeValue(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Email"
                  value={previousValue}
                  onChange={(e) => setPreviousValue(e.target.value)}
                  error={!!emailError}
                  helperText={emailError}
                />
                <TextField
                  fullWidth
                  label="Date of Birth"
                  type="date"
                  value={inputValues?.customerDob || ""}
                  onChange={(e) =>
                    setInputValues((prev) => ({
                      ...prev,
                      customerDob: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                />
                <div className="flex justify-end gap-3 mt-6">
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={closeEditModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCustomerDetailsSave}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </>
          </Box>
        </Modal>
      )}
      {viewImage && (
        <Modal
          open={Array.isArray(viewImage) ? viewImage.length > 0 : !!viewImage}
          onClose={handleViewClose}
        >
          <Box sx={imagestyle}>
            <h1 className="text-xl mb-4">View Document</h1>
            <div className="flex justify-center gap-4 flex-wrap">
              {Array.isArray(viewImage) ? (
                // show up to 2 images side-by-side, handle non-image links too
                viewImage.slice(0, 2).map((item, idx) => {
                  // item might be an object with filePath or url, or a string
                  const src =
                    typeof item === "string"
                      ? item
                      : item?.url || item?.filePath || "";

                  const fileName =
                    typeof item === "string" ? null : item?.fileName;

                  // simple image type check by file extension
                  const isImage =
                    typeof src === "string" &&
                    /(\.|\/)(jpg|jpeg|png|gif|bmp|webp)$/i.test(src);

                  return isImage ? (
                    <>
                      <img
                        key={idx}
                        src={src}
                        alt={fileName || `Document ${idx + 1}`}
                        className="max-h-[70vh] object-contain rounded-lg shadow-md"
                        style={{ maxWidth: "48%" }}
                      />

                      <a target="_blank" href={src} download={"image"}>
                        <button class="cursor-pointer group relative flex gap-1.5 px-4 py-4 bg-black bg-opacity-80 text-[#f1f1f1] rounded-3xl hover:bg-opacity-70 transition font-semibold shadow-md">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            height="24px"
                            width="24px"
                          >
                            <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                            <g
                              stroke-linejoin="round"
                              stroke-linecap="round"
                              id="SVGRepo_tracerCarrier"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <g id="Interface / Download">
                                {" "}
                                <path
                                  stroke-linejoin="round"
                                  stroke-linecap="round"
                                  stroke-width="2"
                                  stroke="#f1f1f1"
                                  d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                                  id="Vector"
                                ></path>{" "}
                              </g>{" "}
                            </g>
                          </svg>
                        </button>
                      </a>
                    </>
                  ) : (
                    <div
                      key={idx}
                      className="p-4 bg-gray-100 rounded-md"
                      style={{ maxWidth: "48%" }}
                    >
                      <p className="font-semibold">
                        {fileName || `Attachment ${idx + 1}`}
                      </p>
                      {src ? (
                        <a
                          href={src}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-blue-600"
                        >
                          Open
                        </a>
                      ) : (
                        <p className="text-sm text-gray-600">
                          No preview available
                        </p>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="flex justify-center">
                  <img
                    src={viewImage}
                    alt="Customer Document"
                    className="max-h-[70vh] object-contain w-full rounded-lg shadow-md"
                  />
                </div>
              )}
            </div>
            <div className="flex justify-end gap-4 mt-4">
              {!selectedRow?.isVerified && (
                <>
                  {" "}
                  <Button
                    onClick={() => {
                      approveCustomerDocuments("approve");
                    }}
                    variant="contained"
                    color="success"
                  >
                    Approve
                  </Button>
                  <Button
                    onClick={() => {
                      approveCustomerDocuments("reject");
                    }}
                    variant="contained"
                    color="danger"
                  >
                    Reject
                  </Button>
                </>
              )}
              <Button
                onClick={handleViewClose}
                variant="contained"
                color="error"
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      )}

      {openImage && (
        <Modal
          keepMounted
          open={openImage}
          onClose={handleImageClose}
          aria-labelledby="keep-mounted-modal-title"
        >
          <Box sx={imagestyle}>
            <div>
              <h1 className="text-2xl">Add Documents</h1>
              <div className="grid grid-cols-2 gap-6 mt-8">
                {customerDocumentsField.map((field, idx) => {
                  if (field.type === "text" || field.type === "date") {
                    return (
                      <TextField
                        key={idx}
                        fullWidth
                        label={field.label}
                        value={inputValues[field.value] || ""}
                        variant="outlined"
                        type={field.type}
                        onChange={(e) => handleInputChange(field.value, e)}
                        error={!!errors[field.value]} // <-- no special case
                        helperText={errors[field.value] || ""} // <-- always show message
                        InputLabelProps={{ shrink: true }}
                      />
                    );
                  } else if (field.type === "dropdown") {
                    return (
                      <FormControl
                        fullWidth
                        error={!!errors[field.value]}
                        key={idx}
                      >
                        <InputLabel>{field.label}</InputLabel>
                        <Select
                          value={inputValues[field.value] || ""}
                          onChange={(e) => {
                            setInputValues({});
                            setSelectedFile(null);
                            setErrors({});
                            handleInputChange(field.value, e);
                          }}
                          label={field.label}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: 200, // Limits dropdown height (optional)
                              },
                            },
                          }}
                        >
                          {field.subCategory?.map((option, index) => (
                            <MenuItem
                              sx={{
                                minHeight: 20, // Smaller height
                                paddingY: 0.5, // Compact vertical padding
                                fontSize: "0.8rem", // Smaller font (optional)
                              }}
                              key={index}
                              value={option.id}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{errors[field.value]}</FormHelperText>
                      </FormControl>
                    );
                  } else if (field.type === "file") {
                    return (
                      <div key={idx}>
                        <label
                          htmlFor="file"
                          className="w-full h-10 px-2 rounded-[10px] bg-[rgba(0,110,255,0.075)] cursor-pointer flex items-center justify-end gap-2 text-black border-none"
                        >
                          Upload Photo (Front and Back)
                        </label>
                        <div className="flex gap-4 p-4">
                          {selectedFile &&
                            selectedFile?.map((image, index) => {
                              return (
                                <img
                                  alt="image preview"
                                  src={
                                    image?.url ||
                                    image?.filePath ||
                                    image?.Location ||
                                    image
                                  }
                                  className="h-44 w-44 object-cover"
                                />
                              );
                            })}
                        </div>
                        <input
                          id="file"
                          type="file"
                          onChange={handleFileChange}
                          className="hidden"
                          multiple
                        />
                        {inputValues.uploadfile && (
                          <p className="text-sm mt-1 text-green-600">
                            {inputValues.uploadfile}
                          </p>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
              {isFormValid() && (
                <button
                  onClick={handleSave}
                  className="flex justify-center mt-6 items-center gap-2 w-28 h-12 cursor-pointer rounded-md shadow-2xl text-white font-semibold bg-gradient-to-r from-[#fb7185] via-[#e11d48] to-[#be123c] hover:shadow-xl hover:shadow-red-500 hover:scale-105 duration-300 hover:from-[#be123c] hover:to-[#fb7185]"
                >
                  + Save
                </button>
              )}
            </div>
            {loading && (
              <div>
                <BlinkBlur
                  color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                />
              </div>
            )}
          </Box>
        </Modal>
      )}

      <div className="md:p-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
            Customer Details
          </h2>
          <div className="flex gap-3">
            {actionsToAccess?.includes("Update Customer") && <button
              onClick={() => {
                openEditModal("customer", "");
              }}
              className="flex items-center gap-2 px-5 h-10 py-2 bg-green-600 text-white text-base font-medium rounded-lg shadow-md hover:bg-green-700 active:bg-green-800"
            >
              <EditSquareIcon className="text-lg" />
              <span>Edit Customer Details</span>
            </button>}
            <button
              onClick={() => {
                setInputValues({});
                setSelectedFile(null);
                setErrors({});
                handleImageOpen("new");
              }}
              className="flex items-center gap-2 px-5 h-10 py-2 bg-blue-600 text-white text-base font-medium rounded-lg shadow-md hover:bg-blue-700 active:bg-blue-800"
            >
              <span className="text-2xl">+</span>
              <span>Update Document</span>
            </button>
          </div>
        </div>

        <InfoTable
          title="Personal Information"
          rows={[
            ["Full Name", summaryDetails?.customerName || "N/A", null],
            [
              "Date of Birth",
              profileInfo?.dob || formatDate(profileInfo?.dob),              
            ],
            [
              "Age",
              moment().diff(moment(profileInfo?.dob), "years") || "N/A",
              null,
            ],
            ["Gender", summaryDetails?.gender || "N/A", null],
            ["Nationality", summaryDetails?.nationality || "N/A", null],
          ]}
        />

        <div className="max-h-80 overflow-y-auto mt-8 shadow-lg border border-gray-100">
          <table className="min-w-full text-sm text-left">
            <thead className="sticky top-0 bg-gray-400 text-white rounded-lg shadow">
              <tr>
                <th className="p-4">Document Name</th>
                <th className="p-4">Document No</th>
                <th className="p-4">Name</th>
                <th className="p-4">Description</th>
                <th className="p-4">Valid From</th>
                <th className="p-4">Valid To</th>
                <th className="p-4 text-right">Verified</th>
                <th className="p-4">Approved By</th>
                <th className="p-4">Upload On</th>
                <th className="p-4">Action</th>
                <th className="p-4">Edit</th>
              </tr>
            </thead>
            <tbody>
              {customerDocuments && customerDocuments.length > 0 ? (
                customerDocuments.map((doc, index) => (
                  <tr
                    key={doc?.id || index}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="p-3">
                      {customerDocumentType[doc?.docType]}
                    </td>
                    <td className="p-3">{doc?.identificationNo}</td>
                    <td className="p-3">{doc?.docName}</td>
                    <td className="p-3">{doc?.description || "-"}</td>
                    <td className="p-3">{formatDate(doc?.startDate) || "-"}</td>
                    <td className="p-3">{formatDate(doc?.endDate) || "-"}</td>
                    <td className="p-3 text-right">
                      {doc?.isVerified
                        ? "Verified"
                        : doc?.isRejected === true
                          ? "Rejected"
                          : doc?.isVerified === false && "Not Verified"}
                    </td>
                    <td className="p-3">
                      {systemUserData?.find(
                        (item) => item?.id === doc?.approvedBy,
                      )?.name || "-"}
                    </td>

                    <td className="p-3">
                      {doc?.createdAt ? formatDateAndTime(doc?.createdAt) : "-"}
                    </td>
                    <td
                      onClick={() => {
                        // Build an array of attachments to view.
                        const attachments = [];

                        if (doc?.attachments) {
                          const parsed = JSON.parse(doc.attachments);
                          if (Array.isArray(parsed)) {
                            parsed.forEach((item) => attachments.push(item));
                          } else {
                            attachments.push(parsed);
                          }
                        }

                        try {
                          const parsed = doc?.attachments
                            ? JSON.parse(doc.attachments)
                            : null;

                          if (Array.isArray(parsed) && parsed.length) {
                            parsed.forEach((att) => {
                              if (att?.filePath) attachments.push(att.filePath);
                              else if (att?.url) attachments.push(att.url);
                              else attachments.push(att);
                            });
                          }
                        } catch (err) {
                          // attachments might already be an array/object
                          if (
                            doc?.attachments &&
                            Array.isArray(doc.attachments)
                          ) {
                            doc.attachments.forEach((att) =>
                              attachments.push(att),
                            );
                          }
                        }

                        // fallback to imageUrl or first attachment
                        const toView = attachments.length
                          ? attachments
                          : doc?.imageUrl || null;
                        handleViewOpen(toView);

                        setSelectedRow(doc);
                      }}
                      className="p-4 text-right cursor-pointer"
                    >
                      <HowToRegIcon
                        className={`h-6 w-6 ${
                          doc?.isVerified
                            ? "text-green-500"
                            : doc?.isRejected === true
                              ? "text-red-500"
                              : doc?.isVerified === false && "text-gray-500"
                        }`}
                      />
                    </td>
                    <td className="p-3">
                      <EditSquareIcon
                        onClick={() => handleImageOpen("edit", doc)}
                        className="h-6 w-6 cursor-pointer"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center p-4 text-gray-500">
                    No documents found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <InfoTable
          title="Contact Information"
          rows={[
            [
              "Primary Mobile",
              <div className="flex items-center gap-3">
                {summaryDetails?.customerMobile || "N/A"}

                {summaryDetails?.customerMobile && (
                  <span
                    className="cursor-pointer px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition flex items-center gap-1 select-none"
                    title="Call Customer"
                    onClick={() =>
                      makeCustomerCall(summaryDetails?.customerMobile)
                    }
                  >
                    Call 📞
                  </span>
                )}
              </div>,
            ],
            [
              "Email Address",
              <div className="flex items-center">
                {profileInfo?.email || "N/A"}
                {profileInfo?.email && (
                  <ContactButton
                    icon="📧"
                    label="Email"
                    action="Email"
                    onClick={() => contactAction("Email", profileInfo?.email)}
                  />
                )}
              </div>,              
            ],
          ]}
        />
        {showCapture && (
          <div className="mt-3 flex items-center gap-3 bg-yellow-50 p-3 rounded-md border">
            <span className="text-sm">
              After the call. Click capture to store call log.
            </span>

            <button
              onClick={captureCallDetails}
              className="px-4 py-1 bg-green-600 text-white rounded"
            >
              Capture
            </button>
          </div>
        )}

        {callLogs.length > 0 && (
          <div className="mt-4 bg-white border rounded-lg p-3">
            <h3 className="font-semibold mb-2">📞 Call Logs</h3>

            <table className="w-full text-sm border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 border">From</th>
                  <th className="p-2 border">To</th>
                  <th className="p-2 border">Status</th>
                  <th className="p-2 border">Start Date & Time</th>
                  <th className="p-2 border">End Date & Time</th>
                  <th className="p-2 border">Duration</th>
                  <th className="p-2 border w-12">Recording Url</th>
                  <th className="p-2 border w-12">Action</th>
                </tr>
              </thead>

              <tbody>
                {callLogs.map((call, index) => (
                  <tr key={index}>
                    {console.log("callLogs", callLogs)}
                    <td className="p-2 border">{call?.callFrom}</td>
                    <td className="p-2 border">{call?.callTo}</td>
                    <td className="p-2 border">{call?.callStatus}</td>
                    <td className="p-2 border">
                      {formatDateAndTime(call?.startTime)}
                    </td>
                    <td className="p-2 border">
                      {formatDateAndTime(call?.endTime)}
                    </td>
                    <td className="p-2 border">{call?.duration} sec</td>
                    <td className="p-2 border w-12">
                      <a
                        className="text-blue-500"
                        href={call?.recordingUrl}
                        target="_blank"
                      >
                        {call?.recordingUrl || "-"}
                      </a>
                    </td>
                    {call?.callStatus !== "completed" ? (
                      <td className="p-2 border w-12">
                        <button
                          onClick={() => {
                            captureCallDetails(call?.sId);
                          }}
                          className="px-4 py-1 bg-green-600 text-white rounded"
                        >
                          Capture
                        </button>
                      </td>
                    ) : (
                      "Not Required"
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Customerdetails;
